/* reveal.js — one IntersectionObserver for the whole page */
(function () {
  "use strict";
  var prefersReduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReveal() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!els.length) return;
    if (prefersReduced || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible", "is-done"); });
      return;
    }
    document.querySelectorAll("[data-reveal-group]").forEach(function (group) {
      group.querySelectorAll("[data-reveal]").forEach(function (kid, i) {
        if (!kid.style.getPropertyValue("--reveal-i")) kid.style.setProperty("--reveal-i", i);
      });
    });
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add("is-visible");
        obs.unobserve(el);
        el.addEventListener("transitionend", function () { el.classList.add("is-done"); }, { once: true });
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initImages() {
    document.querySelectorAll(".media-reveal img").forEach(function (img) {
      if (img.complete && img.naturalWidth) { img.classList.add("is-loaded"); return; }
      img.addEventListener("load", function () { img.classList.add("is-loaded"); }, { once: true });
      img.addEventListener("error", function () { img.classList.add("is-loaded"); }, { once: true });
    });
  }

  function init() { initReveal(); initImages(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
